module.exports = __webpack_public_path__ + "media/app/images/campaign_cta@2x-844484deec664f49de4e74caad70390d.png";